/**
 * Re-export SuperSonic English block strings from scratch-vm (single source of truth).
 */
module.exports = require('../../../scratch-vm/src/extensions/scratch3_supersonic/l10n-en');
